const industrys = [
  {
    name:"传媒",
    children:[
      {name:"网络广告",},
      {name:"综合广告",},
      {name:"影视制作",},
      {name:"文化传播",},
      {name:"电视台",},
      {name:"音乐制作",},
    ],
  },
  {
    name:"房地产",
    children:[
      {name:"房地产经纪",},
      {name:"房地产开发",},
      {name:"高尔夫",},
      {name:"家居连锁",},
      {name:"建筑工程",},
      {name:"建筑设计院",},
      {name:"景观园林",},
      {name:"连锁酒店",},
      {name:"连锁商超",},
      {name:"零售百货",},
      {name:"商业地产",},
      {name:"物业",},
      {name:"星级酒店",},
      {name:"装饰设计",},
    ]
  },
  {    
    name:"高科技",
    children:[
      {name:"3S",},
      {name:"IC",},
      {name:"IT咨询",},
      {name:"LED制造",},
      {name:"第三方支付",},
      {name:"电子商务",},
      {name:"分销",},
      {name:"高科技制造",},
      {name:"互联网及SP",},
      {name:"家电行业",},
      {name:"软件及系统集成",},
      {name:"软件外包",},
      {name:"手机制造",},
      {name:"游戏",},
      {name:"通讯行业",},
      {name:"液晶制造",},
      {name:"医疗器械",},
      {name:"智能交通",},
    ]
  },
  {
    name:"金融",
    children:[
      {name:"P2P",},
      {name:"PE",},
      {name:"保险",},
      {name:"保险公估",},
      {name:"保险经纪",},
      {name:"财务公司",},
      {name:"担保",},
      {name:"基金",},
      {name:"交易所",},
      {name:"期货",},
      {name:"信托",},
      {name:"信用卡",},
      {name:"银行",},
      {name:"证券",},
      {name:"租赁",},
    ]
  },
  {
    name:"能源化工",
    children:[
      {name:"电池",},
      {name:"电气",},
      {name:"风场投资运营",},
      {name:"风电",},
      {name:"光伏",},
      {name:"化工",},
      {name:"环保水务",},
      {name:"矿开采",},
      {name:"燃气",},
      {name:"石油",},
      {name:"输变电",},
      {name:"水泥",},
      {name:"涂料",},
      {name:"有色金属",},
      {name:"地质勘查",},
    ]
  }, 
  {
    name:"物流",
    children:[
      {name:"船运",},
      {name:"航空",},
      {name:"航空维修",},
      {name:"物流",},
    ]
  },
  {     
    name:"消费品",
    children:[
      {name:"淀粉",},
      {name:"纺织",},
      {name:"家具",},
      {name:"酒业",},
      {name:"日化",},
      {name:"奢侈品",},
      {name:"食品饮料",},
      {name:"饲料",},
      {name:"塑料",},
      {name:"香精香料",},
      {name:"鞋服",},
      {name:"印刷",},
      {name:"纸业",},
      {name:"珠宝",},
      {name:"玩具",},
      {name:"保健品",},
    ]
  },
  {  
    name:"医药",
    children:[
      {name:"血液制品",},
      {name:"医药流通",},
      {name:"医药研发",},
      {name:"医药综合",},
      {name:"生物工程",},
    ]
  },
  {
    name:"制造",
    children:[
      {name:"船舶制造",},
      {name:"电梯制造",},
      {name:"机械制造",},
      {name:"轮胎制造",},
      {name:"摩托车制造",},
      {name:"汽车销售",},
      {name:"汽车制造",},
      {name:"五金制造",},
      {name:"电动车",},
      {name:"水泥制造",},
      {name:"建材制造",},
    ]
  },
  {      
    name:"专业服务",
    children:[
      {name:"中介",},
      {name:"人力资源",},
      {name:"商业服务",},
      {name:"外包",},
      {name:"律师",},
      {name:"心理",},
      {name:"检测",},
      {name:"租赁",},
      {name:"认证",},
      {name:"财务",},
      {name:"在线教育",},
      {name:"艺术培训",},
      {name:"养老院",},
      {name:"体检中心",},
      {name:"旅游",},
      {name:"公关",},
      {name:"餐饮",},
    ]
  },
  {
    name:"公共管理",
    children:[
      {name:"卫生系统",},
      {name:"水利环境系统",}
    ]
  },
  {
    name:"贸易",
    children:[
      {name:"外贸",}
    ]
  }
];
export default industrys;